import { KeycloakRole, MekUser } from "@newsenec/auth-provider";
import { LoginState } from "./flow";

export function getCockpitUserAuthState(user: MekUser): LoginState {
    if (user.devNumber === undefined) return "notRegistered";

    if (user.fromKeycloak) {
        return user.keycloakRoles?.some((role) => role === KeycloakRole.Installer
            || role === KeycloakRole.ExternalServiceProvider) ? "authorized" : "unauthorized";
    } else {
        return "authorized";
    }
}

export function getControlUserAuthState(user: MekUser): LoginState {
    const allowedRoles = [
        KeycloakRole.Technical_Service.valueOf(),
        KeycloakRole.Customer_Support.valueOf(),
        KeycloakRole.Sales.valueOf(),
        KeycloakRole.Stakeholder.valueOf(),
    ];
    return user.keycloakRoles?.some((role) => allowedRoles.includes(role)) ? "authorized" : "unauthorized";
}

export function isEmailVerified(user: MekUser): boolean {
    return user.email_verified === true;
}
